export default "__VITE_ASSET__xmI7H892__"